import {Component, OnInit} from '@angular/core';
import {UserComponent} from "../../../../shared/user/user.component";
import {DataColumn} from "../../../../models";
import {
  ReferenceTitleComponent
} from "../../../../pages/etablissement/missions/reference-title/reference-title.component";
import {
  CandidaturesMissionComponent
} from "../../../../pages/etablissement/missions/encour-component/components/candidatures-mission/candidatures-mission.component";
import {
  TableEnCourActionComponent
} from "../../../../pages/etablissement/missions/encour-component/components/table-en-cour-action/table-en-cour-action.component";
import {Mission} from "../../../../models/Mission";
import {Site} from "../../../../models/Site";
import moment from "moment/moment";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {MissionService} from "../../../../services/mission.service";
import {FormBuilder, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {EstablishmentService} from "../../../../services/establishment.service";
import {AuthService} from "../../../../services/auth.service";
import {debounceTime, skip} from "rxjs";
import {removeBlankAttributes} from "../../../../shared/utils/utils.functions";
import {filterListDone, filterListDoneInterim} from "../../../../shared/utils/data/etablissments-data";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {NgIf} from "@angular/common";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";
import {SharedModule} from "../../../../shared/shared.module";
import {SvgIconComponent} from "angular-svg-icon";
import {
  MissionTableActionsComponent
} from "../encour-component/components/mission-table-actions/mission-table-actions.component";
import {MissionDetailsComponent} from "../encour-component/mission-details/mission-details.component";

@Component({
  selector: 'app-agency-terminated-mission-for-etab',
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    NgIf,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    SharedModule,
    SvgIconComponent
  ],
  templateUrl: './agency-terminated-mission-for-etab.component.html',
  styleUrl: './agency-terminated-mission-for-etab.component.scss'
})
export class AgencyTerminatedMissionForEtabComponent implements OnInit {
  // filterList = [
  //   {label : 'Terminés',value : CandidatStatusOnMission.ARCHIVED},
  //   {label : 'Confirmés',value : CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH},
  //   {label : 'Acceptés',value : CandidatStatusOnMission.ACCEPTED},
  //   {label : 'Publiés',value : CandidatStatusOnMission.NEUTRAL},
  //   {label : 'Non publiés',value : CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION},
  // ]
  component: any[] = [UserComponent];
  randomData: any[] = [];
  isLoading: boolean = false;
  // Define the custom columns array
  customColumns: DataColumn[] = [
    {
      header: 'Référence',
      fieldName: 'missionTitle',
      component: ReferenceTitleComponent,
      dataType: 'component',
      col: 'col',
    },
    { header: 'Site', fieldName: 'site', dataType: 'string',  col: 'col',},
    {
      header: 'Service d’affectation',
      fieldName: 'serviceAffectationsName',
      dataType: 'string',
      col: 'col',
    },
    { header: 'Poste', fieldName: 'typePoste', dataType: 'string',col: 'col', },
    {
      header: 'Type de contrat',
      fieldName: 'typecontat',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Dates',
      fieldName: 'duration',
      fieldNameStartDate: 'startdate',
      fieldNameEndDate: 'enddate',
      dataType: 'date',
      col: 'col',
    },
    {
      header: 'Rémunération',
      fieldName: 'compensationproposednet',
      fieldNameCurrency: 'currency',
      dataType: 'currency',
      col: 'col',
    },
    {
      header: 'Candidatures',
      fieldName: 'candidatures',
      dataType: 'component',
      component: CandidaturesMissionComponent,
      col: 'col',
    },

    {
      header: 'Statut',
      fieldName: '',
      component: TableEnCourActionComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },
    {
      header: 'Actions',
      fieldName: '',
      component: MissionTableActionsComponent,
      dataType: 'component',
      col: 'col',
      unClickable: true,
    },
  ];
  id: number;
  missionList: Mission[] = [];
  offset = 0;
  size = 10;
  totalItems = 0;
  siteList: Site[] = [];

  formFilter = this.fb.group({
    adresseId: undefined,
    endDate: [moment(new Date()).local()], //moment(new Date()).format('yyyy-MM-DD')
    missionTitle: [''],
    page: 0,
    size: 10,
    startDate: [''],
    // "Filtrer par date": keep missions whose span contains this date (startdate <= date <= enddate).
    activeOnDate: [<any>null],
    missionStatus: [[]],
    statusOfCandidatOnMission: [[]],
  });

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private api: MissionService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private auth: AuthService
  ) {
    this.id = this.route.snapshot.params['establishmentId']??0;
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.fetshMission();
    // Refresh the table whenever an action mutates a mission (cancel, delete, status change…).
    this.api.getRefreshMission().pipe(skip(1)).subscribe(() => this.fetshMission());
    this.getSitesByEstablishment();
    this.formFilter.valueChanges.pipe(debounceTime(700)).subscribe((value) => {
      this.fetshMission();
    });

    // #6 Reset to the first page whenever the search term changes (etab terminées).
    this.formFilter.get('missionTitle')?.valueChanges.subscribe(() => {
      this.formFilter.get('page')?.patchValue(0, { emitEvent: false });
      this.offset = 0;
    });
  }

  getSitesByEstablishment() {
    this.establishmentService
      .getSiteByEstablishmentId(this.id, true)
      .subscribe({
        next: (res) => {
          this.siteList = res;
        },
        error: () => {},
      });
  }

  fetshMission(): void {
    this.isLoading = true;
    const body: any = { ...this.formFilter.value };
    // Normalize the "active on date" filter to a start-of-day datetime the backend can parse.
    if (body.activeOnDate) {
      body.activeOnDate = moment(body.activeOnDate).format('YYYY-MM-DDT00:00:00');
    }
    this.api
      .getMissionsByEstablishmentId(
        removeBlankAttributes(body),
        this.id
      )
      .subscribe({
        next: (res: { content: Mission[]; totalElements: number }) => {
          this.missionList = res.content.map((mission) => {
            if (mission.typecontat == 'LIBERAL') {
              mission.typecontat = 'Intérim';
            }
            mission.site = mission?.adresseDto?.name??'';
            return mission;
          });
          this.totalItems = res.totalElements;
        },
        error: () => {},
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  handleRowClick = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: {...row , etbId: this.id},
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        this.fetshMission();
      }
    });
  };
  pagination(event: any) {
    this.offset = event.pageIndex * this.size;
    this.formFilter.get('page')?.patchValue(event.pageIndex);
    this.fetshMission();
  }

  toggleSelectSite(event: any, site: Site) {
    if (event) {
      // @ts-ignore
      this.formFilter.get('adresseId')?.patchValue(site.id);
    } else {
      this.formFilter.get('adresseId')?.patchValue('');
    }
  }

  get addressId(): any {
    return this.formFilter.get('adresseId')?.value;
  }

  protected readonly filterListDone = filterListDoneInterim;
}
